import services from './../../../services/service'; // Service Class

let service = new services();

export default {
    name: 'Orders',
    data () {
        return {
          user: {},
          orders:{},
          order: {},
          img_product_url: service.imageProductsURL,
          loading:true,
        }
      },
    components: {
        
      },
      
    methods:{
        setOrder(order){
            this.order = order;
        },

        preset() {
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                            this.getOrders();
                        }, this);
                    }else {
                    this.$router.push('login');
                    }
                }).catch((err) => {
                    if(err) {
                        this.$router.push('login');
                        //console.log(err)
                    }
                })
            }else {
            this.$router.push('login');
            }
        },

        getOrders(){
            service.getOrders(this, this.user.user_id).then(response => {
                if(response.body.status == 200) {
                    this.orders = response.body.data;
                    this.orders.set = true;
                    this.loading = false;
                }
            }).catch((err) => {
                //console.log(err) //possibly a load payment error
            })
        },

    },
    created(){
        document.title = "Orders" + " | SP";
        //clear/remove if order stored in local forage
        localforage.clear(function () {}).catch(function(err) {});
        //this.prepCart();
        this.preset();
    }
     
}


// WEBPACK FOOTER //
// ./src/pages/Buypoint/Orders/script.js